import { DialogPrimitive } from "@gigpro/ui/Dialog";
import { Sheet, SheetClose, SheetContent } from "@gigpro/ui/Sheet";
import type React from "react";
import type { NavItem } from "../types";
import { SidebarItem } from "./SidebarItem";

type DrawerProps = {
  open: boolean;
  onOpenChanged: (open: boolean) => void;
  items: Array<NavItem>;
  slots?: { bottom?: React.ReactNode };
};

export const Drawer: React.FC<DrawerProps> = ({ open, onOpenChanged, items, slots }) => (
  <Sheet open={open} onOpenChange={onOpenChanged}>
    <SheetContent className="flex w-48 flex-col text-black">
      <DialogPrimitive.Title className="sr-only">Navigation Menu</DialogPrimitive.Title>
      <SheetClose className="absolute top-3 right-3" />
      <div className="h-8 w-full shrink-0" />
      <div className="min-h-0 w-full flex-1 overflow-auto py-1">
        {items.map((item, index) => (
          <SidebarItem
            // eslint-disable-next-line react/no-array-index-key
            key={item.type === "divider" ? index : item.title}
            item={item}
            onClick={() => onOpenChanged(false)}
          />
        ))}
      </div>
      {slots?.bottom && <div className="z-10 pt-2 shadow-top">{slots.bottom}</div>}
    </SheetContent>
  </Sheet>
);
